import { StatusTone } from '@/components/ui/statusTone.ts';
import { AttentionSeverity } from '@/types/stats/AttentionSeverity.ts';

/**
 * Waga sprawy na ton. `CRITICAL` idzie `error`, a nie `caution`, bo zaległa
 * rata to nie stan nieodwracalny, tylko rzecz do naprawienia dzisiaj.
 */
export const ATTENTION_SEVERITY_TONE: Record<AttentionSeverity, StatusTone> = {
  [AttentionSeverity.CRITICAL]: 'error',
  [AttentionSeverity.WARNING]: 'warning',
  [AttentionSeverity.INFO]: 'info',
};

export const getAttentionSeverityTone = (
  severity: AttentionSeverity,
): StatusTone => ATTENTION_SEVERITY_TONE[severity];
